module.exports = __webpack_public_path__ + "img/image-02.656bec56.jpeg";